import { TestType } from "@/queries/types";
import styled from "@emotion/styled";

export const Content = styled.div<{
  startedTest: boolean;
  testType: TestType;
}>`
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
  margin-top: 48px;
  z-index: 1;

  @media (min-width: 768px) {
    width: calc(100% - 108px);
    margin-left: 84px;
    margin-right: 24px;
    margin-top: 0;
    padding: 0 8px 80px 8px;
  }

  @media (min-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
    width: ${(props) =>
      props.testType === "video" && props.startedTest
        ? (16 / 24) * 100
        : (14 / 24) * 100}%;
  }

  @media (min-width: 1440px) {
    width: ${(props) =>
      props.testType === "video" && props.startedTest
        ? (18 / 24) * 100
        : (12 / 24) * 100}%;
  }
`;
